import { render, staticRenderFns } from "./tatTable.vue?vue&type=template&id=f0ef7e20"
import script from "./tatTable.vue?vue&type=script&lang=js"
export * from "./tatTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports